import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "text"
};
import { nextTick } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'MenuBlock',
  props: {
    modelValue: {},
    list: {}
  },
  emits: ["update:modelValue", "tabClick", "change"],
  setup(__props, {
    emit: __emit
  }) {
    const emits = __emit;
    const handleTabClick = async val => {
      emits('tabClick', val);
      await nextTick();
      emits('change', val);
    };
    return (_ctx, _cache) => {
      const _component_el_tooltip = _resolveComponent("el-tooltip");
      const _component_el_tab_pane = _resolveComponent("el-tab-pane");
      const _component_el_tabs = _resolveComponent("el-tabs");
      return _openBlock(), _createBlock(_component_el_tabs, {
        "model-value": __props.modelValue,
        type: "card",
        class: _normalizeClass(["tab-block", {
          'sty-one': __props.list.length === 1
        }]),
        onTabClick: handleTabClick,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => emits('update:modelValue', $event))
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.list, item => {
          return _openBlock(), _createBlock(_component_el_tab_pane, {
            key: item.value,
            name: item.value,
            disabled: item.disabled
          }, {
            label: _withCtx(() => [_createVNode(_component_el_tooltip, {
              disabled: !item.label || item.label.length <= 6,
              content: item.label,
              "popper-class": "tooltip"
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_1, _toDisplayString(item.label), 1)]),
              _: 2
            }, 1032, ["disabled", "content"])]),
            _: 2
          }, 1032, ["name", "disabled"]);
        }), 128))]),
        _: 1
      }, 8, ["model-value", "class"]);
    };
  }
});